<template>
  <div ref="wrapper" :class="partnerClass" :style="adZoneStyles">
    <div v-if="storyFeed && !isMobile" class="video-card-container">
      <video-card :project="project" :post="post"></video-card>
      <div v-if="isSeeingMore" class="adcontainer is-flex">
        <doubleclickad path="/14357335/EngCom_new_BigBox1" :size="[[300, 600], [300, 250]]"
        :primaryCategory="project.primaryCategoryID" :articleType="articleType" :articleID="articleID" :key="articleID"></doubleclickad>
      </div>
    </div>
    <h1 v-if="storyFeed && !isMobile" class="title">{{project.title}}</h1>
    <h2 v-if="storyFeed && !isMobile" class="sub-title">{{project.description}}</h2>
    <span ref="displayBody"
          class="html-span-override is-clearfix"
          :class="{
            hideElements,
            'is-article': isEngArticle,
            'ql-editor': isComment,
            'ql-view': isComment ,
            'finalistBoothCardFix': isFinalistBooth
          }"
          v-html="displayBody"
          @click="checkClick"
          qa="post-title" v-highlight />
    <div v-if="storyFeed && isMobile && isSeeingMore" class="adcontainer is-flex">
      <doubleclickad path="/14357335/EngCom_new_BigBox1" :size="[[300, 600], [300, 250]]"
      :primaryCategory="project.primaryCategoryID" :articleType="articleType" :articleID="articleID" :key="articleID"></doubleclickad>
    </div>
    <div v-show="false">
      <quill-editor ref="quillRef" v-model="html"/>
    </div>
    <zoom-image ref="zoomImage" />
  </div>
</template>

<script>
import QuillEditor from '@/components/Inputs/QuillEditor'
import ZoomImage from '@/components/Controls/ZoomImage'
import VideoCard from '../../Pages/StoryFeed/VideoCard'
import textSanitize from '@/libs/text-sanitize'
import adZones from './adZones'
import Doubleclickad from '@/components/Modals/DoubleClickAd'
import breakpoints from '@/libs/breakpoints'

const messagePreviewCutoff = 250

export default {
  props: ['content', 'maxLength', 'isHeader', 'hideElements', 'placeHolder', 'previewMode', 'isEngArticle', 'storyFeed', 'project', 'post', 'isSeeingMore', 'isComment'],
  mixins: [adZones],
  components: { QuillEditor, ZoomImage, VideoCard, Doubleclickad },
  data: function () {
    return {
      body: this.placeHolder ? this.placeHolder : '',
      html: ''
    }
  },
  mounted: function () {
    if (this.content && this.content.length > 0) {
      this.setBody(this.content)
    } else if (this.$slots && this.$slots.default && this.$slots.default.length > 0) {
      this.setBody(this.$slots.default[0].text)
    }
  },
  watch: {
    content: function (value) {
      value && this.setBody(value)
    }
  },
  updated: function () {
    this.setZoomImage()
  },
  computed: {
    isFinalistBooth: function () {
      return this.$route.name === 'iseffinalistbooth'
    },
    displayBody: function () {
      return this.previewMode ? this.messagePreview : this.body
    },
    webRoot: function () {
      return process.env.WEB_ROOT
    },
    partnerClass: function () {
      return 'htmlview htmlview-' + process.env.APP_NAME.toLowerCase()
    },
    messagePreview: function () {
      const message = this.body
      if (!message) {
        return ''
      }

      // truncate messages 25% longer than our cutoff
      const length = message.length
      if (length / messagePreviewCutoff >= 1.25) {
        return `${message.substring(0, messagePreviewCutoff)}...`
      }

      return message
    },
    articleType: function () {
      return this.project?.article?.type || ''
    },
    articleID: function () {
      return this.project?.article?.id || 0
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  methods: {
    setBody: function (body) {
      this.body = textSanitize.replace(this.$refs.quillRef.getHTML(body, this.maxLength), this.webRoot)
    },
    getHTML: function () {
      return this.body
    },
    checkClick: function (event) {
      let link = null
      const target = event.target

      if (target && target.tagName.toLowerCase() === 'a') {
        link = target
      }
      if (!link && target) {
        const parent = target.parentNode
        if (parent && parent.tagName.toLowerCase() === 'a') {
          link = parent
        }
      }

      if (link) {
        const linkOuterHtml = link.outerHTML
        const hrefRegex = /href="(.*?)"/g
        const hrefUrl = hrefRegex.exec(linkOuterHtml)

        const httpRegex = /^(http|https)/
        let linkUrl = hrefUrl[1]
        if (httpRegex.test(linkUrl.toLowerCase()) === false) {
          linkUrl = 'https://' + linkUrl
        }

        window.open(linkUrl)
        event.preventDefault()
      }
    },
    setZoomImage: function () {
      const selectedHTML = this.$refs.displayBody
      const embeddedImages = selectedHTML.getElementsByTagName('IMG')
      embeddedImages.forEach(image => {
        image.addEventListener('click', this.$refs.zoomImage.getImage)
        image.addEventListener('keypress', this.$refs.zoomImage.getImage)
        image.classList.add('zoom-in', 'focus-state')
        image.setAttribute('tabindex', '0')
      })
    }
  }
}
</script>

<style lang="scss">
  .finalistBoothCardFix {
    @media screen and (max-height: 875px){
      display: none;
    }
  }
  .html-span-override {
    @import '~styles/markdown.scss';
    width:100%;
    p {
      margin: 0;
      &.image-center {
        width: 100%;
        img {
          margin: 0 auto;
        }
      }
      &.image-inset-right {
        display: flex;
        justify-content: center;
        max-width: 100%;
        float: none !important;
        margin: 0;
        img {
          width: 100%;
        }
      }
      &.caption {
        margin: 0 auto;
        float: none !important;
      }
    }
    pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    }
    h2 {
      margin: 0.5rem 0;
    }
    a, p, h1, li, blockquote{
      background: transparent;
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    }

    &.is-article {
      p,
      p.caption {
        display: inline-block;
      }
    }

    &.hideElements {
      em, img, iframe {
        display: none;

      }
      p:not(:empty) {
        padding-bottom: 1rem;
      }
    }
  }
  .text{
    margin: 1rem 0.25rem;
  }
  .zoom-in {
    cursor: zoom-in;
    &:focus {
      transition: 0.3s ease-in;
      transform: scale(1.02)
    }
  }
  .mention {
    color: #00adee;
  }

  .htmlview {
    width: 100%;
  }

  .htmlview-neweng {
    p {
      padding: 0.8rem 0.1rem;
    }
  }
  .html-span-override .ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
    border-radius: 3px;
    width: 100%;
  }
  p.ad-zone-two {
    margin-bottom: var(--ad-two-height);
  }
  @media (max-width: 1200px) {
    p.ad-zone-one {
      margin-bottom: var(--ad-one-height);
    }
  }
  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-justify {
    text-align: justify;
  }
  .ql-view.ql-editor {
    min-height: unset;
    padding: 0;
    white-space: unset;
    line-height: unset;
  }
</style>
<style lang="scss" scoped>
@import '~styles/utils.scss';
  .video-card-container {
    float: right;
    width: 50%;
    padding-left: 1rem;
    padding-bottom: 1rem;
  }
  .adcontainer {
    padding-top: 3rem;
    padding-left: 3rem;
    @include mobile {
      justify-content: center;
      width: 100%;
      padding-top: 0;
      padding-left: 0;
    }
  }
</style>
